module.exports = __webpack_public_path__ + "img/banner.2600a82b.png";